import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import { commandWorkspaceCollaboratorSummary } from '../actions';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { accountOrTeamIds, collaboratorType, workspaceId, permissionLevel } = action;

  const workspacePermissionGrant = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PERMISSION_GRANT,
    [`${collaboratorType}Ids`]: accountOrTeamIds,
    workspaceId,
    permissionLevel,
  });

  if (workspacePermissionGrant.type === constants.RTM_WORKSPACE_PERMISSION_GRANT_OK) {
    yield put(commandWorkspaceCollaboratorSummary(workspaceId));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: workspacePermissionGrant.message || <FormattedMessage {...messages.permissionGrantError} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_GRANT_PERMISSION, catchErrors, sendRequest, connection);
}
